const baseURL = 'https://sebas.mundonet.co';

export default baseURL;
